<template>
  <div v-if="loading" class="flex justify-center">
    <div
      class="w-10 h-10 min-w-10 min-h-10 rounded-full border-8 border-white border-t-blue-cumulus-200-active border-r-blue-cumulus-200-active animate-spin"
    ></div>
  </div>
  <div v-else-if="favorites.length" class="mb-2 -mx-2">
    <p class="text-xl font-bold">Les derniers destinataires</p>
    <ul>
      <li class="fav-row flex" v-for="fav in favorites" :key="fav.mail">
        <button
          @click="emit('select', fav)"
          class="w-full text-start outline-offset-4 hover:bg-grey-850 p-1 flex items-center group"
          :data-sentry-id="`FavUser-${fav.mail}`"
        >
          <span>
            {{ fav.fullName }}
          </span>
          <OhVueIcon :name="sendIcon" class="text-blue-france-sun-113 ml-auto invisible group-hover:visible" />
        </button>
        <PButton
          size="icon"
          mode="tertiary-borderless"
          class="bg-white"
          @click="remove(fav.id)"
          :data-sentry-id="`FavUserDelete-${fav.mail}`"
          :aria-label="`Supprimer ${fav.mail}`"
        >
          <OhVueIcon :name="trashIcon" />
        </PButton>
      </li>
    </ul>
  </div>
</template>

<script setup lang="ts">
import { onMounted, ref } from "vue";
import { useFavoriteUserApi } from "../http/favorite-user.api";
import { FavoriteUserType } from "../dto/favorite-user.dto";
import { type AgentsDirectoryAutocompleteItem } from "../dto/agents-directory.dto";
import { OhVueIcon } from "oh-vue-icons";
import { RiUserSharedLine, RiDeleteBin6Line } from "oh-vue-icons/icons";
import { useIcons, PButton } from "@pasta/box-v2";

const emit = defineEmits<{
  (event: "select", value: AgentsDirectoryAutocompleteItem & { id: number }): void;
}>();

const [sendIcon, trashIcon] = useIcons(RiUserSharedLine, RiDeleteBin6Line);

const favoriteUserApi = useFavoriteUserApi();
const favorites = ref<(AgentsDirectoryAutocompleteItem & { id: number })[]>([]);

const loading = ref(false);
async function refresh() {
  loading.value = true;
  try {
    favorites.value = await favoriteUserApi.getMine(FavoriteUserType.PRIVATE_MESSAGE);
  } finally {
    loading.value = false;
  }
}
onMounted(refresh);

async function remove(id: number) {
  await favoriteUserApi.delete(id);
  await refresh();
}
</script>

<style scoped>
@reference "@pasta/box-v2/tailwind.css";

.fav-row:nth-of-type(even) {
  @apply bg-grey-975;
}

.fav-row:nth-of-type(odd) {
  @apply bg-grey-950;
}
</style>
